import { useGlobalStore } from '@/stores/GlobalStore.ts';
import {
  ApiError,
  BadGatewayError,
  ConnectionTimeoutError,
  InternalServerError,
  NetworkUnavailableError,
  NotImplementedError,
  ServiceUnavailableError,
  CanceledError,
} from '@/api/errors.ts';

// Success handling functions

export const successMessage = (message: string) => {
  const store = useGlobalStore();

  store.$q.notify({
    message: message,
  });
};

// Error handling functions

const shouldSuppressError = (error: unknown): boolean =>
  error instanceof CanceledError ||
  error instanceof NetworkUnavailableError ||
  error instanceof ConnectionTimeoutError;

const shouldShowGenericFriendlyMessage = (error: unknown): boolean =>
  error instanceof InternalServerError ||
  error instanceof NotImplementedError ||
  error instanceof BadGatewayError ||
  error instanceof ServiceUnavailableError;

export const errorMessage = (errorOrMessage: unknown, color: string = 'red') => {
  const store = useGlobalStore();

  // If it's a string, show it directly
  if (typeof errorOrMessage === 'string') {
    store.$q.notify({ message: errorOrMessage, color });
    return;
  }

  // If we should suppress this error, return early
  if (shouldSuppressError(errorOrMessage)) {
    return;
  }

  // If it's an ApiError and we want to show a specific message
  if (errorOrMessage instanceof ApiError && !shouldShowGenericFriendlyMessage(errorOrMessage)) {
    store.$q.notify({ message: errorOrMessage.message, color });
    return;
  }

  // Fallback generic message
  store.$q.notify({
    message: 'Something went wrong.',
    color,
  });
};
